<template>
  <CCardImage
    :orientation="orientation || undefined"
    v-bind="$attrs"
  />
</template>

<script>
import { CCardImage } from '@coreui/vue-pro'

export default {
  name: 'CCardImg',
  components: { CCardImage },
  inheritAttrs: false,
  props: {
    orientation: { type: String, default: '' },
  },
}
</script>
